import { Link as RouterLink } from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { ArrowLeftIcon } from '../../../assets/icons';

const BackToLogin = () => {
    const classes = useStyles();

    return (
        <Grid container className={classes.link}>
            <Link component={RouterLink} to="/">
                <ArrowLeftIcon />
                Voltar para Login
            </Link>
        </Grid>
    );
}

export default BackToLogin;

const useStyles = makeStyles<Theme>((theme) =>
    createStyles({
        link: {
            marginTop: theme.spacing(3),
            justifyContent: "center",

            "& a": {
                fontSize: 16,
                fontWeight: "bold",
                color: theme.palette.primary.contrastText,
                display: "flex",
                alignItems: "center",

                "& svg": {
                    marginRight: theme.spacing(1),
                },
            },
        },
    }))